<template>
  <div class="search-input">
    <el-autocomplete
      class="inline-input"
      :popper-append-to-body="false"
      v-model="searchInfo"
      :fetch-suggestions="querySearchAsync"
      :trigger-on-focus="false"
      placeholder="搜索影片名"
      @select="handleSearchSelect"
    >
      <i class="el-icon-search el-input__icon" slot="prefix"></i>
    </el-autocomplete>
  </div>
</template>

<script>
import { trim } from "lodash";
import movieApi from "../../api/movieApi.js";
export default {
  name: "searchInput",
  props: {},
  data() {
    return {
      movieApi: new movieApi(),
      searchInfo: undefined
    };
  },
  computed: {},
  methods: {
    formatQueryResult(data) {
      return data.map((item, index) => {
        return {
          value: item.movie_name || item.movie.title,
          id: item.movie ? item.movie.id : null
        };
      });
    },
    async querySearchAsync(queryString, cb) {
      //call api to query movies fit to the search-name
      let res = await this.movieApi.getMovieByTitle({
        title: trim(queryString)
      });
      if (res.status !== true || res.code !== 200) {
        throw new Error("请求电影信息错误");
        return;
      }
      //format return result
      let suggestion = this.formatQueryResult(res.data);
      //return res to the complete-component
      cb(suggestion);
    },
    handleSearchSelect(data) {
      //data like {value:**,id:**}
      //jump to the detail page
      // this.setMainMovie(data.id);
      this.$router.push({
        name: "movieLib",
        query: { searchInfo: encodeURIComponent(data.value) }
      });
    }
    // setMainMovie(id) {
    //   console.log(id);
    //   // return
    //   this.$store.commit("movie/setMainMovie", { id: id });
    //   this.$store.commit("movie/updateTotalMovieState");
    //   this.$router.push({
    //     path: "movies",
    //     query: { compaire_type: "single" }
    //   });
    // }
  },
  watch: {},
  created() {}
};
</script>

<style lang="scss" scoped>
.search-input {
  width: 90%;
}
.inline-input {
  width: 100%;
}
/deep/ .el-input__inner {
  height: 2.5em;
  font-size: 15px;
  border-radius: 1.25em;
  border: none;
  background-color: #f1f1f1;
}
/deep/ .el-autocomplete-suggestion {
  left: 0px !important;
}
</style>
